<template>
  <div id="pointsPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="امتیازات"></ActionBar>
    <div  v-if="isContentLoaded">
    <div class="row container mx-auto p-0 mt-2">
      <div class="col-12 p-0 rounded-b-lg header-rounded bg-white card-shadow">
        <div class="third-background header-rounded  white--text p-1 font16px"></div>
      <div class="col-12 text-center font-weight-bold"><i class="fas fa-star star-icon"></i> موجودی امتیاز:
        {{ totalInputPoint - totalOutputPoint }} امتیاز
      </div>
      </div>
      <div class="col-12 col-sm-10 col-md-6 col-lg-6 p-0 mb-4 mx-auto my-5">
        <div class="member-ship-tab p-2 d-flex justify-space-between">
          <v-btn :class="{active: receivedPoints}" class="px-lg-16 px-7" color="third" rounded
                 @click="showReceivedPoints"><span class="font12px">امتیازات دریافتی</span>
          </v-btn>
          <v-btn :class="{active: usedPoints}" class=" px-lg-16" color="third" rounded
                 @click="showUsedPoints"><span class="font12px">امتیازات کسر شده</span>
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="receivedPoints">
      <div class="row container mx-auto no-gutters p-0 mt-3">
        <div class="col-12  rounded-b-lg header-rounded bg-white card-shadow">
          <div class="third-background header-rounded  white--text p-2 font16px">رکورد امتیازات</div>
          <div class="row no-gutters">
            <div v-for="item in items" :key="item.StudentPointID" class="col-12 light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters">
                <div class="col-8 mt-1 font11px">{{ item.Description }}</div>
                <div class="col-3 font10px ">{{ $convertDate(item.ModifiedDate) }}</div>
                <!--                <div :class="item.type ? 'green-span' : 'red-span'"-->
                <!--                     class="white&#45;&#45;text col-2 font12px text-center mt-1 ">-->
                <div class="green-span white--text col-1 text-center mt-1 ">
                  <div class="font11px">{{ item.Amount }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 py-2 px-1 pl-3"><span class="float-right font12px font-weight-bold">مجموع امتیازات دانش آموز</span><span
              class="float-left font12px font-weight-bold">{{ totalInputPoint }} امتیاز</span></div>
        </div>
      </div>
    </div>
    <div v-if="usedPoints">
      <div class="row container mx-auto no-gutters p-0 mt-2">
        <div class="col-12  rounded-b-lg header-rounded bg-white card-shadow">
          <div class="third-background header-rounded  white--text p-2 font16px">امتیازات مصرفی</div>
          <div class="row no-gutters">
            <div v-for="item in usedPointsItems" :key="item.StudentPointID"
                 class="col-12 light-gray-bottom-border px-md-2 p-1">
              <div class="row no-gutters">
                <div class="col-8 mt-1 font11px">{{ item.Description }}</div>
                <div class="col-3 font10px ">{{ $convertDate(item.ModifiedDate) }}</div>
                <!--                <div :class="item.type ? 'green-span' : 'red-span'"-->
                <!--                     class="white&#45;&#45;text col-2 font12px text-center mt-1 ">-->
                <div class="red-span white--text col-1 text-center mt-1 ">
                  <div class="font11px">{{ Math.abs(item.Amount) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 py-2 px-1 pl-3"><span
              class="float-right font12px font-weight-bold">مجموع امتیازات مصرفی</span><span
              class="float-left font12px font-weight-bold">{{ totalOutputPoint }} امتیاز</span></div>
        </div>
      </div>
    </div>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "Points",
  metaInfo: {
    title: 'مسیربرتر-امتیازات'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    receivedPoints: true,
    usedPoints: false,
    items: [],
    usedPointsItems: [],
    showLoaderDialog: false,
    isContentLoaded: false,
    totalInputPoint: null,
    totalOutputPoint: null,
  }),
  mounted() {
    _this = this;
    this.showLoaderDialog = true;
    this.getInputPoint();
    this.getOutputInput();
  },
  methods: {
    getInputPoint() {
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "StudentPointManagement/ListInput", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            let sum = 0
            for (let i = 0; i < json.length; i++) {
              sum += Math.abs(json[i].Amount)
            }
            _this.totalInputPoint = sum
            _this.items = json;
            _this.isContentLoaded = true
            _this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getOutputInput() {
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "StudentPointManagement/ListOutPut", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            let sum = 0
            for (let i = 0; i < json.length; i++) {
              sum += Math.abs(json[i].Amount)
            }
            _this.totalOutputPoint = sum
            _this.usedPointsItems = json;
            _this.isContentLoaded = true
            _this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    showReceivedPoints() {
      this.receivedPoints = true;
      this.usedPoints = false
    },
    showUsedPoints() {
      this.receivedPoints = false;
      this.usedPoints = true
    }
  }
}
</script>
